module.exports = __webpack_public_path__ + "img/drive.e9c83219.jpg";